<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="container">
      <div class="left">
        <el-tree :data="options2" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
      </div>
      <div class="right">
        <div class="search-line">
          <div style="display:flex;justify-content:flex-start;align-items:center;">
            <button-add @click="toAddPage" value="添加授权" v-if="permissionCodes.indexOf('') !== -1"></button-add>
            <button-delete @deleteSelection="deleteSelection" value="删除授权" v-if="permissionCodes.indexOf('') !== -1"></button-delete>
          </div>
        </div>
        <table-main :tableHead="tableHead" :tableData="tableData" :operationArr="operationArr" @wantChangeInput="wantChangeInput" @changeInputChange="changeInputChange" @deleteLine="deleteLine" @changeSelection="changeSelection" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" @changePagination="changePagination" :total="total" @goToModifyPage="goToModifyPage"/>
      </div>
    </div>

    <el-dialog
      title="人员列表"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
    >
      <el-input disabled v-model="deviceCode" class="input-with-select" size="small" style="margin-bottom: 10px;" />
      <el-input placeholder="请输入人员名称搜索" v-model="requestPersonData.searchKey" class="input-with-select" @keyup.13.native="getPersonList" size="small" style="margin-bottom: 10px;">
      </el-input>
      <table-main :tableHeight="300" :tableHead="tablePersonHead" :tableData="tablePersonData" :relTableSelectData="personCodes" :total="personTotal" :pageNum="requestPersonData.pageNum" :pageSize="requestPersonData.pageSize" :hasOperation="false" @changePagination="changePersonPagination" @changeSelection="changePersonSelection"/>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="confirmPublish">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/Lock";
import { bus } from "../../../utils/bus";
import { errorHandler } from "../../../utils/errorHandler";
import ButtonAdd from "../../../components/common/buttons/button-add";
import {nAlert, nError, nSuccess} from "../../../utils/notice";

export default {
  components: {
    ButtonAdd,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    Breadcrumb
  },
  name: "lock-authorization-manage",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "智慧门锁",
          name: "lock-concentrator-manage"
        },
        {
          value: "权限管理"
        }
      ],
      fixTypeList: [],
      tableHead: [
        // {
        //   prop: "roomNumber",
        //   label: "房间号"
        // },
        // {
        //   prop: "lockDeviceCode",
        //   label: "门锁编号"
        // },
        {
          prop: "personName",
          label: "姓名"
        },
        {
          prop: "phone",
          label: "手机号"
        },
        {
          prop: "fingerprint",
          label: "指纹"
        },
        {
          prop: "cardNumber",
          label: "卡",
          width: "180px",
          changeLockInput2: true,
        },
        {
          prop: "password",
          label: "密码",
          width: "180px",
          changeLockInput: true,
        }
      ],
      tableData: [],
      operationArr: ["delete"],
      requestData: {
        searchKey: "",
        pageSize: 10,
        pageNum: 1
      },
      requestPersonData: {
        pageSize: 10,
        pageNum: 1,
        searchKey: ""
      },
      uploadUrl: "",
      total: 0,
      selectionArr: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      options:[],
      options2:[],
      roomList:[],

      roomCode:'',
      deviceCode:'',
      dialogVisible: false,
      tablePersonHead: [
        {
          prop: "name",
          label: "姓名"
        },
        {
          prop: "phone",
          label: "手机号"
        },
        {
          prop: "enterpriseName",
          label: "所属住户"
        }
      ],
      tablePersonData:[],
      personTotal: 0,
      personCodes:[],
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
    this.getBuildingList()
  },
  activated() {
    this.getPage();
  },
  methods: {
    getBuildingList(){
      this.$axios.post(api.getBuildingList,{}).then(res=>{
        let list=res.data.data
        let options=[]
        list.map(v=>{
          let  temp={}
          temp.label=v.name
          temp.value=v.code
          temp.children=[]
          options.push(temp)
          v.floors.map(u=>{
            let temp2={}
            temp2.label=u.name
            temp2.value=u.code
            temp2.children=[]
            temp.children.push(temp2)
          })
        })
        this.options=options
        this.getRoomInfoList()
      }).catch(errorHandler('获取楼栋列表失败'))
    },
    getRoomInfoList(){
      this.$axios.post(api.getRoomInfoList,{}).then(res=>{
        let list =res.data.data
        let options=this.options
        options.map(v=>{
          v.children.map(u=>{
            list.map(z=>{
              if(u.value==z.floorCode){
                let temp={}
                temp.value= z.code
                temp.label= z.roomNumber
                u.children.push(temp)
              }
            })
          })
        })
        let yqName=sessionStorage.getItem('yqName')
        let yqCode=sessionStorage.getItem('yqCode')
        let a=[{label: yqName, value: yqCode, children: []}]
        a[0].children=options
        this.options2=a
        this.roomList=list
      }).catch(errorHandler('获取房间列表失败'))
    },
    handleNodeClick(data) {
      this.roomCode=data.value
      this.getLockByRoomCode()
      this.getPage()
    },
    getLockByRoomCode(){
      this.$axios.get(api.getLockByRoomCode+'/'+this.roomCode).then(res=>{
        if(res.data.data){
          this.deviceCode=res.data.data.deviceCode
        }else {
          this.deviceCode=''
        }
      }).catch(errorHandler("查询失败"))
    },
    getPage() {
      this.requestData.roomCode=this.roomCode
      this.$axios
        .post(api.getAuthorizedPage, this.requestData)
        .then(res => {
          this.total = res.data.data.total;
          let list = res.data.data.list;
          list.map(v=>{
            v.changeCardNumberDisabled = true;
            v.changePasswordDisabled = true;
          })
          this.tableData = list;
        })
        .catch(errorHandler("获取分页失败"));
    },
    deleteLine(code) {
      this.$axios
        .post(api.deleteAuthorizedByCodes, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("删除成功");
            this.selectionArr = [];
            this.getPage();
          }
        })
        .catch(errorHandler("删除失败"));
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },
    deleteSelection(){
      if(this.selectionArr.length==0){
        nError("请选择要删除授权的人员")
        return false;
      }else{
        this.$confirm("是否确认删除授权？", "提示")
          .then(() => {
            this.deleteLine(this.selectionArr)
          })
          .catch(() => {
            console.log("取消删除");
          });
      }
    },

    toAddPage() {
      if(!this.deviceCode){
        nError('请选择带有门锁的房间进行权限添加')
        return false
      }
      this.getPersonList()
      this.dialogVisible=true

      // this.$router.push({
      //   name: "lock-authorization-add"
      // });
    },
    goToModifyPage(code) {
      this.$router.push({
        path: `lock_gate_modify/${code}`
      });
    },
    searchKey(v) {
      this.requestData.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.requestData.pageNum = data[0];
      this.requestData.pageSize = data[1];
      this.getPage();
    },
    changePersonPagination(data){
      this.requestPersonData.pageNum = data[0];
      this.requestPersonData.pageSize = data[1];
      this.getPersonList();
    },

    getPersonList() {
      this.$axios
        .post(api.getPersonList, this.requestPersonData)
        .then(res => {
          if (res.data.retCode === 1) {
            let list = res.data.data.list;
            this.tablePersonData = list;
            this.personTotal = res.data.data.total;
            this.personList = list;
          }
        })
        .catch(errorHandler("获取人员列表失败"));
    },
    handleClose() {
      this.dialogVisible= false;
    },
    changePersonSelection(codeArr) {
      console.log(codeArr)
      this.personCodes = codeArr;
    },
    confirmPublish() {
      this.dialogVisible = false;
      this.$axios.post(api.addAuthorized,{
        roomCode:this.roomCode,
        lockDeviceCode:this.deviceCode,
        personCodes:this.personCodes,
      }).then(res=>{
          nSuccess('添加权限成功');
          this.getPage()
      }).catch(errorHandler('添加权限失败'))
    },

    wantChangeInput(data,key) {
      if(key=='cardNumber'){
        this.tableData.map(v=>{
          if(v.code==data.code){
            v.cardNumber=''
            v.changeCardNumberDisabled = false;
          }
        })
      }else if(key=='password'){
        this.tableData.map(v=>{
          if(v.code==data.code){
            v.password=''
            v.changePasswordDisabled = false;
          }
        })
      }
    },

    // 单个配置
    changeInputChange(data,key) {
      let reqData={}
      reqData.code=data.code
      if(key=='cardNumber'){
        if(data.cardNumber==''){
          this.getPage()
          return false;
        }else{
          reqData.cardNumber=data.cardNumber
        }
      }else if(key=='password'){
        if(data.password==''){
          this.getPage()
          return false;
        }else{
          reqData.password=data.password
        }
      }
      this.$axios
        .post(api.updateAuthorizedCardNumber, reqData)
        .then(res => {
          nSuccess("配置成功");
          this.getPage();
        })
        .catch(errorHandler("配置失败"));
    },
  }
};
</script>


<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.container{
  display: flex;
}
.left{
  flex: 1;
  border-right: 1px solid #e6ebf2;
}
.right{
  flex: 3;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/GateLock/GateLockAuthorization/LockAuthorizationManage.vue